/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_DA_DK: Record<string, string> = {
    ariaAnnounceChart: 'diagram, ${seriesCount}[number] serier',
    ariaAnnounceFlowProportionLink: 'link ${index} af ${count}, fra ${from} til ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'node ${index} af ${count}, ${description}',
    ariaAnnounceGaugeChart: 'målerdiagram, ${caption}',
    ariaAnnounceHierarchyChart: 'hierarkisk diagram, ${caption}',
    ariaAnnounceHierarchyDatum: 'niveau ${level}[number], ${count}[number] børn, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Tryk på mellemrumstasten eller Enter for at skifte synlighed',
    ariaLabelAddHorizontalLine: 'Tilføj vandret linje',
    ariaLabelAnnotationOptionsToolbar: 'Annotationmuligheder',
    ariaLabelAnnotationSettingsDialog: 'Anmærkningsindstillinger',
    ariaLabelColorPicker: 'Farvevælger',
    ariaLabelFinancialCharts: 'Finansielle diagrammer',
    ariaLabelLegend: 'Forklaring',
    ariaLabelLegendItem: '${label}, Legend element ${index}[number] af ${count}[number]',
    ariaLabelLegendItemUnknown: 'Ukendt element i legenden',
    ariaLabelLegendPageNext: 'Næste legendeside',
    ariaLabelLegendPagePrevious: 'Forrige legenda-side',
    ariaLabelLegendPagination: 'Legend paginering',
    ariaLabelNavigator: 'Navigator',
    ariaLabelNavigatorMaximum: 'Maksimum',
    ariaLabelNavigatorMinimum: 'Minimum',
    ariaLabelNavigatorRange: 'Rækkevidde',
    ariaLabelRangesToolbar: 'Områder',
    ariaLabelSettingsTabBar: 'Indstillinger',
    ariaLabelZoomToolbar: 'Zoom',
    ariaValuePanRange: '${min}[percent0to2dp] til ${max}[percent0to2dp]',
    contextMenuDownload: 'Download',
    contextMenuPanToCursor: 'Panorer hertil',
    contextMenuToggleOtherSeries: 'Skift Andre Serier',
    contextMenuToggleSeriesVisibility: 'Skift synlighed',
    contextMenuZoomToCursor: 'Zoom til her',
    dialogHeaderChannel: 'Kanal',
    dialogHeaderDatePriceRange: 'Dato og Pris',
    dialogHeaderDateRange: 'Datointerval',
    dialogHeaderFibonacciRange: 'Fib Tilbageførsel',
    dialogHeaderLine: 'Linje',
    dialogHeaderPriceRange: 'Prisinterval',
    dialogHeaderText: 'Tekst',
    dialogInputAlign: 'Justering',
    dialogInputColorPicker: 'Farve',
    dialogInputColorPickerAltText: 'Tekstfarve',
    dialogInputExtendAbove: 'Udvid over',
    dialogInputExtendBelow: 'Forlæng nedenfor',
    dialogInputExtendChannelEnd: 'Forlæng kanalende',
    dialogInputExtendChannelStart: 'Forlæng kanalstart',
    dialogInputExtendLeft: 'Udvid til venstre',
    dialogInputExtendLineEnd: 'Forlæng linjens ende',
    dialogInputExtendLineStart: 'Forlæng linjestart',
    dialogInputExtendRight: 'Udvid til højre',
    dialogInputFibonacciBands: 'Bånd',
    dialogInputFibonacciBandsAltText: 'Fibonacci-bånd',
    dialogInputFillColorPicker: 'Udfyld',
    dialogInputFillColorPickerAltText: 'Fyldfarve',
    dialogInputFontSize: 'Størrelse',
    dialogInputFontSizeAltText: 'Skrifttypestørrelse',
    dialogInputLineStyle: 'Streg',
    dialogInputPosition: 'Position',
    dialogInputReverse: 'Omvendt',
    dialogInputShowFill: 'Vis udfyldning',
    dialogInputStrokeWidth: 'Vægt',
    dialogInputStrokeWidthAltText: 'Linjevægt',
    iconAltTextAlignCenter: 'Centrér',
    iconAltTextAlignLeft: 'Venstre',
    iconAltTextAlignRight: 'Højre',
    iconAltTextClose: 'Luk',
    iconAltTextLineStyleDashed: 'Lang-stiplet',
    iconAltTextLineStyleDotted: 'Kort-stiplet',
    iconAltTextLineStyleSolid: 'Solid',
    iconAltTextPositionBottom: 'Bund',
    iconAltTextPositionCenter: 'Centreret',
    iconAltTextPositionTop: 'Top',
    inputTextareaPlaceholder: 'Tilføj tekst',
    measurerDateRangeBars: '${value}[number] bjælker',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Vol ${value}',
    overlayLoadingData: 'Indlæser data...',
    overlayNoData: 'Ingen data at vise',
    overlayNoVisibleSeries: 'Ingen synlige serier',
    overlayUnsupportedBrowser: 'Uforenelig browserversion. Opdater venligst din browser.',
    seriesHistogramTooltipCount: '${yName} (antal)',
    seriesHistogramTooltipFrequency: 'Frekvens',
    seriesHistogramTooltipMean: '${yName} (gennemsnit)',
    seriesHistogramTooltipSum: '${yName} (sum)',
    toolbarAnnotationsArrow: 'Pil',
    toolbarAnnotationsArrowDown: 'Pil ned',
    toolbarAnnotationsArrowUp: 'Pil Op',
    toolbarAnnotationsCallout: 'Opkald',
    toolbarAnnotationsClearAll: 'Ryd alle',
    toolbarAnnotationsComment: 'Kommentar',
    toolbarAnnotationsDatePriceRange: 'Dato og Pris',
    toolbarAnnotationsDateRange: 'Datointerval',
    toolbarAnnotationsDelete: 'Slet',
    toolbarAnnotationsDisjointChannel: 'Adskilt Kanal',
    toolbarAnnotationsDragHandle: 'Træk værktøjslinje',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Fib Tilbageførsel',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Fib-trendbaseret',
    toolbarAnnotationsFillColor: 'Fyldfarve',
    toolbarAnnotationsHorizontalLine: 'Vandret linje',
    toolbarAnnotationsLineAnnotations: 'Trendlinjer',
    toolbarAnnotationsLineColor: 'Linjefarve',
    toolbarAnnotationsLineStrokeWidth: 'Linje penselbredde',
    toolbarAnnotationsLineStyle: 'Linjestil',
    toolbarAnnotationsLock: 'Lås',
    toolbarAnnotationsMeasurerAnnotations: 'Målere',
    toolbarAnnotationsNote: 'Noter',
    toolbarAnnotationsParallelChannel: 'Parallel kanal',
    toolbarAnnotationsPriceRange: 'Prisklasse',
    toolbarAnnotationsQuickDatePriceRange: 'Mål',
    toolbarAnnotationsSettings: 'Indstillinger',
    toolbarAnnotationsShapeAnnotations: 'Pile',
    toolbarAnnotationsText: 'Tekst',
    toolbarAnnotationsTextAnnotations: 'Tekstantmærkninger',
    toolbarAnnotationsTextColor: 'Tekstfarve',
    toolbarAnnotationsTextSize: 'Tekststørrelse',
    toolbarAnnotationsTrendLine: 'Trendlinje',
    toolbarAnnotationsUnlock: 'Lås op',
    toolbarAnnotationsVerticalLine: 'Lodret linje',
    toolbarRange1Month: '1M',
    toolbarRange1MonthAria: '1 måned',
    toolbarRange1Year: '1År',
    toolbarRange1YearAria: '1 år',
    toolbarRange3Months: '3M',
    toolbarRange3MonthsAria: '3 måneder',
    toolbarRange6Months: '6M',
    toolbarRange6MonthsAria: '6 måneder',
    toolbarRangeAll: 'Alle',
    toolbarRangeAllAria: 'Alle',
    toolbarRangeYearToDate: 'ÅTD',
    toolbarRangeYearToDateAria: 'År til dato',
    toolbarSeriesTypeCandles: 'Stearinlys',
    toolbarSeriesTypeDropdown: 'Diagramtype',
    toolbarSeriesTypeHighLow: 'Høj Lav',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Hule Stearinlys',
    toolbarSeriesTypeLine: 'Linje',
    toolbarSeriesTypeLineWithMarkers: 'Linje med markører',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Trin Linje',
    toolbarZoomPanEnd: 'Pan til slutningen',
    toolbarZoomPanLeft: 'Panorer til venstre',
    toolbarZoomPanRight: 'Panorér til højre',
    toolbarZoomPanStart: 'Pan til starten',
    toolbarZoomReset: 'Nulstil zoom',
    toolbarZoomZoomIn: 'Zoom ind',
    toolbarZoomZoomOut: 'Zoom ud',
    tooltipPaginationStatus: '${index}[number] af ${count}[number]',
};
